import styled from "styled-components";
import {
  toREM,
  toVWDesktop,
  toVWMobile,
} from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import SVG from "react-inlinesvg";
import Link from "../shared/Link";

const PICTURE_MOBILE_HEIGHT = 337;
const PICTURE_DESKTOP_HEIGHT = 400;

const CONTENT_MOBILE_HEIGHT = 300;
const CONTENT_DESKTOP_HEIGHT = 250;

const OFFSET_MOBILE = 24;
const OFFSET_DESKTOP = 120;

export const Picture = styled.img`
  width: 100%;
  height: ${toVWMobile(PICTURE_MOBILE_HEIGHT)}vw;
  object-fit: cover;
  object-position: center;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 100%;
    height: ${toVWDesktop(PICTURE_DESKTOP_HEIGHT)}vw;
  }
`;

export const Content = styled.div`
  color: #ffffff;
  width: 100%;
  padding: ${toVWMobile(24)}vw ${toVWMobile(16)}vw;
  z-index: 1;
  position: absolute;
  height: ${toVWMobile(CONTENT_MOBILE_HEIGHT)}vw;
  bottom: 0;
  left: 0;
  background-color: #033305;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  &:nth-of-type(2) {
    z-index: 0;
    opacity: 0;
  }
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: ${toVWDesktop(CONTENT_DESKTOP_HEIGHT)}vw;
    padding: ${toVWDesktop(20)}vw;
  }
  transition-duration: 200ms;
  transition-timing-function: ease-out;
  & p {
    transition-duration: 200ms;
    transition-timing-function: ease-out;
  }
`;

export const Date = styled.p`
  color: #ffffff;
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-weight: 800;
  font-size: ${toREM(18)}rem;
  line-height: ${toVWMobile(22)}vw;
  justify-self: start;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: end;
  width: 50%;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    line-height: ${toVWDesktop(22)}vw;
  }
`;

export const Type = styled(Date)<{ color: string }>`
  text-align: start;
  color: ${(props) => props.color};
`;

export const Title = styled.p`
  color: #ffffff;
  height: -webkit-fill-available;
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${toREM(24)}rem;
  font-weight: 900;
  line-height: ${toVWMobile(29)}vw;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-top: ${toVWMobile(10)}vw;
  margin-bottom: auto;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    line-height: ${toVWDesktop(29)}vw;
    margin-top: ${toVWDesktop(10)}vw;
  }
`;

export const BottomLink = styled.div<{ color?: string }>`
  position: absolute;
  bottom: 0;
  right: 0;
  border: none;
  background: transparent;
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${toREM(16)}rem;
  font-weight: 700;
  font-style: normal;
  grid-column: 2/3;
  letter-spacing: ${toREM(0.16)}rem;
  text-decoration: none;
  text-align: end;
  width: fit-content;
  padding: ${toVWMobile(24)}vw ${toVWMobile(16)}vw;
  opacity: 0;
  visibility: hidden;
  transition-duration: 200ms;
  transition-timing-function: ease-out;
  color: #033305;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${toVWDesktop(20)}vw;
  }
`;

export const Arrow = styled(SVG)`
  margin-left: ${toVWMobile(8)}vw;
  width: ${toVWMobile(20)}vw;
  height: ${toVWMobile(11)}vw;
  z-index: 1;
  fill: #033305;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-left: ${toVWDesktop(8)}vw;
    width: ${toVWDesktop(20)}vw;
    height: ${toVWDesktop(11)}vw;
  }
`;

export const Container = styled(Link)`
  position: relative;
  cursor: pointer;
  width: ${toVWMobile(PICTURE_MOBILE_HEIGHT)}vw;
  height: ${toVWMobile(
    PICTURE_MOBILE_HEIGHT + CONTENT_MOBILE_HEIGHT,
  )}vw;
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  overflow: hidden;
  text-decoration: none;
  padding-bottom: ${toVWMobile(300)}vw;
  &:hover {
    & ${BottomLink} {
      opacity: 1;
      visibility: visible;
    }
    & ${Content} {
      &:last-of-type {
        z-index: 1;
        opacity: 1;
      }
      height: ${toVWMobile(
        CONTENT_MOBILE_HEIGHT + OFFSET_MOBILE,
      )}vw;
      background-color: #75c154;
    }
    & p {
      color: #033305;
    }
  }
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-bottom: ${toVWDesktop(250)}vw;
    width: ${toVWDesktop(PICTURE_DESKTOP_HEIGHT)}vw;
    height: ${toVWDesktop(
      PICTURE_DESKTOP_HEIGHT + CONTENT_DESKTOP_HEIGHT,
    )}vw;
    &:hover ${Content} {
      height: ${toVWDesktop(
        CONTENT_DESKTOP_HEIGHT + OFFSET_DESKTOP,
      )}vw;
    }
  }
`;
